<template>

    <div v-cloak class="container-fluid">
        <div>
            <div class="row">
                <div class="col">
                    <h4 class="text-portal-soft-black pt-2">{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h4>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <hr class="mt-0 mb-0 border-none taller-hr">
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <h5 class="text-portal-soft-black" v-once>
                        {{ messageModel.requestType == 'TestResultsInquiry_Radiologist' ?  cmsContentBlocks['template.TestResultsInquiry_MSKRadiologist.Title'] : cmsContentBlocks['testResultInquiryComponent.Header']}}
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                    <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
                </div>
            </div>

            <div class="row mt-2 mt-lg-0">
                <div class="col">
                    <div class="row d-none d-lg-block">
                        <div class="col">
                            <hr>
                        </div>
                    </div>
                    <div class="row mt-2 mt-lg-0">
                        <div class="col-12 col-lg-6 pr-lg-0">

                            <div v-if="sendToThisMailbox" class="row text-portal-soft-black mb-2">
                                <div class="col" v-once>
                                    To: {{sendToThisMailbox}}
                                </div>
                            </div>

                            <div v-else>
                                <div v-if="messageModel.requestType == 'TestResultsInquiry_AnyPhysicians'">
                                    <div class="row text-portal-soft-black mb-2">
                                        <div class="col">
                                            {{cmsContentBlocks['generalOfficeCommunicationComponent.ToMailboxLabel']}}
                                        </div>
                                    </div>
                                </div>

                                <div v-if="messageModel.requestType == 'TestResultsInquiry_AnyPhysicians'">
                                    <div class="row mb-2">
                                        <div class="col">
                                            <select2-component key="drDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toMailboxId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="physicianDropDown" v-model="messageModel.toMailboxId" :placeholder="cmsContentBlocks['preCertNameOfMedication.ToDropDownPlaceHolder']">
                                            </select2-component>
                                            <span class="invalid-feedback is-invalid">{{ errorModel.toMailboxId | firstError }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showPhysicianDropDown">
                                <div class="row text-portal-soft-black mb-2">
                                    <div class="col">
                                        {{cmsContentBlocks['testResultInquiryComponent.PhysicianDropDownLabel']}}
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col">
                                        <select2-component key="physDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.toPhysicianId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="reassignPhysicianDropDown" v-model="messageModel.toPhysicianId" :placeholder="cmsContentBlocks['preCertNameOfMedication.ToDropDownPlaceHolder']">
                                        </select2-component>
                                    </div>
                                </div>
                            </div>

                            <div v-if="messageModel.requestType == 'TestResultsInquiry_Radiologist'" class="row text-portal-soft-black mb-2">
                                <div class="col" v-once>
                                    {{cmsContentBlocks['testResultInquiryComponent.ToMailBoxLabel_MSKRadiologist']}}
                                </div>
                            </div>

                            <div class="row text-portal-soft-black mb-2">
                                <div class="col" v-once>
                                    {{cmsContentBlocks['testResultInquiryComponent.SubjectDropDownLabel']}}
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col">
                                    <select2-component key="subjectDropDown" title="Subject of message" v-error-message="{ errorModel: 'errorModel.subjectId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="referenceData.subjectDropDown" v-model="messageModel.subjectId" placeholder="Select subject">
                                    </select2-component>
                                    <span class="invalid-feedback is-invalid">{{ errorModel.subjectId | firstError }}</span>
                                </div>
                            </div>

                            <div class="row text-portal-soft-black mb-2" v-if="showMoreTestQuestions">
                                <div class="col">
                                    <div class="row text-portal-soft-black mb-2">
                                        <div class="col" v-once>
                                            <label for="test-name">{{cmsContentBlocks['testResultInquiryComponent.TestNameLabel']}}</label>
                                        </div>
                                    </div>

                                    <div class="row text-portal-soft-black mb-2">
                                        <div class="col">
                                            <input id="test-name" type="text" :placeholder="cmsContentBlocks['testResultInquiryComponent.TestNameTextBoxPlaceHolder']" v-model="messageModel.testName" v-error-message="{ errorModel: 'errorModel.testName' }" class="form-control" maxlength="200" />
                                            <span class="invalid-feedback is-invalid">{{ errorModel.testName | firstError }}</span>
                                        </div>
                                    </div>

                                    <div class="row text-portal-soft-black mb-2">
                                        <div class="col">
                                            <label for="test-date">{{cmsContentBlocks['testResultInquiryComponent.TestTestDateLabel']}}</label>
                                        </div>
                                    </div>

                                    <div class="row mb-2">
                                        <div class="col">
                                            <div class="input-group">
                                                <date-picker-component ref="preferredDesktop"
                                                                       id="test-date"
                                                                       :typeable="true"
                                                                       v-error-message="{ errorModel: 'errorModel.testDate' }"
                                                                       :disabled-dates="disabledDates"
                                                                       class="form-control vdp-datepickerinput"
                                                                       placeholder="MM / DD / YYYY"
                                                                       format="MM/dd/yyyy"
                                                                       v-model="messageModel.testDate">
                                                </date-picker-component>
                                                <div class="input-group-append">
                                                    <div @click="$refs.preferredDesktop.showCalendar()" class="input-group-text bg-white rounded-right">
                                                        <i class="far fa-calendar-alt text-primary"></i>
                                                    </div>
                                                </div>
                                                <span class="invalid-feedback is-invalid">{{ errorModel.testDate | firstError }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" v-if="messageModel.requestType == 'TestResultsInquiry_AnyPhysicians'">
                                        <div class="col" v-once v-html="cmsContentBlocks['testResultInquiryComponent.TestPerformedOutsideText']">
                                        </div>

                                    </div>

                                    <div class="row text-portal-soft-black mb-2" v-if="messageModel.requestType == 'TestResultsInquiry_AnyPhysicians'">
                                        <div class="col">
                                            <div class="custom-control custom-radio mt-2">
                                                <input type="radio" name="isAtMsk" id="TestAtMsk" v-model="messageModel.testIsAtMsk" class="custom-control-input" :value="true" v-error-message="{ errorModel: 'errorModel.testIsAtMsk' }">
                                                <label for="TestAtMsk" class="custom-control-label">{{cmsContentBlocks['preCertTest.IsTestAtMskTrue']}}</label>
                                            </div>

                                            <div class="custom-control custom-radio mt-2">
                                                <input type="radio" name="isAtMsk" id="TestNotAtMsk" v-model="messageModel.testIsAtMsk" class="custom-control-input" :value="false" v-error-message="{ errorModel: 'errorModel.testIsAtMsk' }">
                                                <label for="TestNotAtMsk" class="custom-control-label">{{cmsContentBlocks['preCertTest.IsTestAtMskFalse']}}</label>
                                            </div>

                                            <span class="d-block invalid-feedback is-invalid">{{errorModel.testIsAtMsk | firstError}}</span>

                                        </div>
                                    </div>

                                    <div v-if="messageModel.testIsAtMsk == false">

                                        <div class="row text-portal-soft-black mb-2">
                                            <div class="col" v-once>
                                                <label for="facility-name">{{cmsContentBlocks['testResultInquiryComponent.FacilityName']}}</label>
                                            </div>
                                        </div>

                                        <div class="row text-portal-soft-black mb-2">
                                            <div class="col">
                                                <input id="facility-name" type="text" :placeholder="cmsContentBlocks['testResultInquiryComponent.FacilityNameTextBoxPlaceHolder']" v-model="messageModel.facilityName" v-error-message="{ errorModel: 'errorModel.facilityName' }" class="form-control" maxlength="250" />
                                                <span class="invalid-feedback is-invalid">{{ errorModel.facilityName | firstError }}</span>
                                            </div>
                                        </div>

                                        <div class="row text-portal-soft-black mb-2">
                                            <div class="col" v-once>
                                                <label for="phone-number">{{cmsContentBlocks['testResultInquiryComponent.PhoneNumberLabel']}}</label>
                                            </div>
                                        </div>
                                        <div class="row text-portal-soft-black mb-2">
                                            <div class="col">
                                                <input id="phone-number" type="text" v-mask="usaPhoneNumberFormat" v-error-message="{ errorModel: 'errorModel.phoneNumber' }" class="form-control" maxlength="25" v-model="messageModel.phoneNumber" :placeholder="cmsContentBlocks['testResultInquiryComponent.PhoneNumberTextBoxPlaceHolder']" />
                                                <span class="invalid-feedback is-invalid">{{ errorModel.phoneNumber | firstError }}</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row text-portal-soft-black mb-2">
                                        <div class="col" v-html="cmsContentBlocks['testResultInquiryComponent.TestResultsFAQLink']"></div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-6">
                            <div class="row">
                                <div class="col">
                                    <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                                    <message-body-component v-model="messageModel.messageBody"
                                                            :error-model="errorModel"
                                                            :non-english="nonEnglish"
                                                            :cms-content-blocks="cmsContentBlocks"></message-body-component>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <upload-component :attachment-group-id="attachmentGroupId">
                                        <template v-slot:multiple-error-slot>
                                            <span class="invalid-feedback is-invalid d-inline">{{ errorModel.attachmentGroupId | firstError }}</span>
                                        </template>
                                    </upload-component>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Vue from 'vue';
    import moment from 'moment';
    import Datepicker from 'vuejs-datepicker';

    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import composeMessageBody from '../../Common/message.body.vue';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import uploadComponent from '@PortalVueComponents/Uploader/file.multiple.uploader.vue';
    import { mask } from 'vue-the-mask'
    import { usaPhoneNumberFormat } from '@SharedServices/formatting.service';
    import { ReferenceDataHttpSvc } from '@SharedHttpServices/reference.data.httpservice';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue';

    export default {
        name: 'testResultInquiryTemplate',
        props: {
            physicianDropDown: { type: Array },
            attachmentGroupId: { type: String },
            errorModel: { type: Object },
            cmsContentBlocks: { type: Object },
            preSelectedRequestTypeId: { type: String },
            preSelectedDefaultToMailboxId: { type: String },
            //if set this is for ITC, DTC, etc. The "To Mailbox Id" will not be shown
            sendToThisMailbox: { type: String },
            //list of Reassign Physicians
            reassignPhysicianDropDown: { type: Array },
            //show or hide Reassign Physicians drop down
            showPhysicianDropDown: { type: Boolean },
            subjectDropDown: { type: Array },
            nonEnglish: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'message-body-component': composeMessageBody,
            'upload-component': uploadComponent,
            'date-picker-component': Datepicker,
            'banner-component': mskBanner
        },
        directives: {
            mask
        },
        data: function () {
            return {
                usaPhoneNumberFormat,

                //only allow dates in the past for the date picker
                disabledDates: {
                    from: new Date(Date.now() - new Date().getMilliseconds())
                },

                referenceData: {
                    subjectDropDown: []
                },

                showMoreTestQuestions: false, //true false

                messageModel: {
                    toMailboxId: this.preSelectedDefaultToMailboxId,
                    toPhysicianId: "", //physician id
                    testName: null,
                    phoneNumber: null,
                    facilityName: null,
                    testDate: null,
                    messageBody: '',
                    attachmentGroupId: this.attachmentGroupId,
                    testIsAtMsk: null, //true-false
                    requestType: this.preSelectedRequestTypeId,
                    subjectId: null,
                },
            }
        },
        mounted: function () {
            this.$emit('setMessageObject', this.messageModel);
        },
        created: function () {

            ReferenceDataHttpSvc.GetComposeMessageSubject('MsgTemplateLabandTestResultsSubjects')
                .done(subjectResponse => {
                    this.referenceData.subjectDropDown = subjectResponse;
                    this.isLoading = false;
                });
        },
        watch: {

            messageModel: {
                handler: function (newValue) {
                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            },
            preSelectedRequestTypeId: function (newValue, oldValue) {
                this.messageModel.requestType = newValue;
            },

            preSelectedDefaultToMailboxId: function (newValue, oldValue) {
                this.messageModel.toMailboxId = newValue;
            },

            'messageModel.subjectId': function (newValue, oldValue) {

                this.showMoreTestQuestions = false;

                if (newValue == 'Ask a question about my results') {
                    Vue.delete(this.errorModel, 'testName');
                    Vue.delete(this.errorModel, 'testDate');
                    Vue.delete(this.errorModel, 'testIsAtMsk');
                    Vue.delete(this.errorModel, 'facilityName');
                    Vue.delete(this.errorModel, 'phoneNumber');
                    this.messageModel.testName = null;
                    this.messageModel.testDate = null;
                    this.messageModel.testIsAtMsk = null;
                    this.messageModel.facilityName = null;
                    this.messageModel.phoneNumber = null;
                    this.showMoreTestQuestions = true;
                }

            },

        },
    };
</script>